import React, { useState } from "react";
import "./Contact.css";
import YouTube from '../assets/youtube.png';
import LinkedIn from '../assets/linkedin.png';

const API_BASE = process.env.REACT_APP_API_URL;

const socials = [
  { name: "YouTube",  img: YouTube,  text: "Visita mi canal", link: "https://www.youtube.com/@NexoCode-z" },
  { name: "LinkedIn", img: LinkedIn, text: "Conéctate",      link: "https://www.linkedin.com/in/nexocode-company-0504202b4/" },
];

const Contact = React.memo(function Contact() {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState({ type: "", msg: "" });
  const [loading, setLoading] = useState(false);

  const handleChange = React.useCallback((e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: "", msg: "" });

    const controller = new AbortController();

    try {
      const res = await fetch(`${API_BASE}/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
        signal: controller.signal
      });

      const data = await res.json();

      if (res.ok) {
        setStatus({ type: "success", msg: "¡Mensaje enviado con éxito! Te contactaré pronto." });
        setFormData({ name: "", email: "", message: "" });
      } else {
        setStatus({ type: "error", msg: data.error || "Ocurrió un error inesperado." });
      }
    } catch (err) {
      if (err.name !== 'AbortError') {
        setStatus({ type: "error", msg: "Error de conexión con el servidor." });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="Contact" className="contact-section">
      <div className="contact-container">
        <div className="contact-info">
          <h2 className="contact-title">📲 Let's Talk</h2>
          <p className="contact-subtitle">
            ¿Tienes un proyecto en mente o una consulta técnica? Estoy listo para ayudarte a llevar tus ideas al siguiente nivel.
          </p>

          <div className="social-grid">
            {socials.map((social, index) => (
              <a key={index} href={social.link} target="_blank" rel="noopener noreferrer" className="social-item">
                <img src={social.img} alt={social.name} />
                <span>{social.text}</span>
              </a>
            ))}
          </div>
        </div>

        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <input 
              type="text" 
              name="name" 
              placeholder="Tu Nombre" 
              value={formData.name} 
              onChange={handleChange} 
              required 
            />
          </div>
          <div className="form-group">
            <input 
              type="email" 
              name="email" 
              placeholder="Tu Email" 
              value={formData.email} 
              onChange={handleChange} 
              required 
            />
          </div>
          <div className="form-group">
            <textarea 
              name="message" 
              placeholder="¿En qué puedo ayudarte?" 
              rows="5"
              value={formData.message} 
              onChange={handleChange} 
              required 
            ></textarea>
          </div>

          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? "Enviando..." : "Enviar Mensaje"}
          </button>

          {status.msg && (
            <div className={`status-message ${status.type}`}>
              {status.msg}
            </div>
          )}
        </form>
      </div>
    </section>
  );
});

export default Contact;
